/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // KUN_SHOP_SCROLL v5: close drawer on click+touch; expose window.kunCloseShopDrawer
  (function kunShopScroll() {
    var SELECTOR = '#drop-01, .kun-drop-01, #shopify-section-section_collection_slider_drop01, [id*="section_collection_slider_drop01"], #shopify-section-section_list_collections_products_f7tDcJ, [id*="section_list_collections_products"]';

    function findDrop() {
      var nodes = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].getBoundingClientRect().height > 40) return nodes[i];
      }
      return document.querySelector('#drop-01');
    }

    function shopLabel(text) {
      if (!text) return false;
      var t = String(text).replace(/\s+/g, ' ').trim().toLowerCase();
      // strip "expand menu" etc
      t = t.replace(/\s*expand menu.*$/,'').trim();
      if (t === 'shop') return true;
      if (t.indexOf('shop') === 0 && t.length <= 12) return true;
      if (t.indexOf('drop 01') === 0 || t.indexOf('drop01') === 0) return true;
      return false;
    }

    function isShopControl(el) {
      if (!el) return false;
      if (el.getAttribute && el.getAttribute('data-kun-shop-scroll') === '1') return true;
      var title = el.querySelector && el.querySelector('.navtext, .sliderow__title');
      if (title && shopLabel(title.textContent)) return true;
      return shopLabel(el.textContent) || shopLabel(el.getAttribute && el.getAttribute('aria-label'));
    }

    function nukeDrawer() {
      var drawer = document.querySelector('[data-drawer="hamburger"]');
      if (!drawer) return false;
      try {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
      } catch (e) {}
      drawer.classList.remove('drawer--visible', 'is-open');
      drawer.classList.add('display-none');
      drawer.style.setProperty('display', 'none', 'important');
      var content = drawer.querySelector('.drawer__content');
      if (content) {
        content.style.setProperty('visibility', 'hidden', 'important');
        content.style.setProperty('transform', 'translate3d(-100%,0,0)', 'important');
      }
      var underlay = drawer.querySelector('[data-drawer-underlay]');
      if (underlay) {
        underlay.style.setProperty('visibility', 'hidden', 'important');
        underlay.classList.remove('underlay--visible');
      }
      document.querySelectorAll('[data-drawer-toggle="hamburger"]').forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      // Click native X (Pipeline toggle close)
      var x = drawer.querySelector('.drawer__close');
      if (x) {
        try { x.click(); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      document.documentElement.classList.remove('scroll-locked');
      document.body.style.overflow = '';
      return true;
    }

    function scrollToDrop() {
      var el = findDrop();
      if (!el) return false;
      var top = el.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      try { history.replaceState(null, '', '#drop-01'); } catch (e) {}
      return true;
    }

    function handleShop(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }
      var path = window.location.pathname || '/';
      var onHome = path === '/' || path === '';
      nukeDrawer();
      setTimeout(nukeDrawer, 0);
      setTimeout(nukeDrawer, 100);
      if (!onHome) {
        window.location.href = '/#drop-01';
        return false;
      }
      setTimeout(scrollToDrop, 50);
      setTimeout(function() { nukeDrawer(); scrollToDrop(); }, 150);
      setTimeout(function() { nukeDrawer(); scrollToDrop(); }, 400);
      return false;
    }

    // Expose for inline onclick from liquid
    window.kunCloseShopDrawer = handleShop;

    function onActivate(e) {
      var el = e.target.closest && e.target.closest('a, button, [data-kun-shop-scroll], .sliderow__title, .sliderow');
      if (!el || !isShopControl(el)) return;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t.indexOf('shop drop') === 0 || t.indexOf('shop all') === 0) return;
      handleShop(e);
    }

    document.addEventListener('click', onActivate, true);
    document.addEventListener('touchend', onActivate, true);
    document.addEventListener('DOMContentLoaded', function() {
      if ((window.location.hash || '') === '#drop-01') {
        nukeDrawer();
        setTimeout(scrollToDrop, 50);
      }
    });
  })();


  // KUN_BRAND_STORY_VIGNETTE_BREATHE v1 — Option D (soft vignette + ~2–3% brightness breathe)
  // Scoped to homepage brand story only. Rollback: delete this IIFE (or remove style#kun-brand-story-vignette-breathe).
  (function kunBrandStoryVignetteBreathe() {
    var STYLE_ID = 'kun-brand-story-vignette-breathe';
    function inject() {
      if (document.getElementById(STYLE_ID)) return;
      // Soft radial vignette + gentle center lift; opacity pulse ≈ subliminal brightness shift on dark ground only (text not filtered).
      var css = ""
        + '[id*="section_richtext_kun_story"] > section[data-section-type="rich-text"],'
        + '[id*="section_richtext_kun_story"] > section.palette--dark {'
        + '  position: relative;'
        + '  isolation: isolate;'
        + '}'
        + '[id*="section_richtext_kun_story"] > section[data-section-type="rich-text"]::before,'
        + '[id*="section_richtext_kun_story"] > section.palette--dark::before {'
        + '  content: "";'
        + '  position: absolute;'
        + '  inset: 0;'
        + '  pointer-events: none;'
        + '  z-index: 0;'
        + '  background: radial-gradient(ellipse 78% 72% at 50% 42%,'
        + '    rgba(255,255,255,0.035) 0%,'
        + '    rgba(255,255,255,0.012) 42%,'
        + '    rgba(0,0,0,0) 68%,'
        + '    rgba(0,0,0,0.20) 100%);'
        + '  opacity: 0.85;'
        + '  animation: kun-story-breathe 10s ease-in-out infinite;'
        + '}'
        + '[id*="section_richtext_kun_story"] > section[data-section-type="rich-text"] > *,'
        + '[id*="section_richtext_kun_story"] > section.palette--dark > * {'
        + '  position: relative;'
        + '  z-index: 1;'
        + '}'
        + '@keyframes kun-story-breathe {'
        + '  0%, 100% { opacity: 0.72; }'
        + '  50% { opacity: 1; }'
        + '}'
        + '@media (prefers-reduced-motion: reduce) {'
        + '  [id*="section_richtext_kun_story"] > section[data-section-type="rich-text"]::before,'
        + '  [id*="section_richtext_kun_story"] > section.palette--dark::before {'
        + '    animation: none !important;'
        + '    opacity: 0.85;'
        + '  }'
        + '}';
      var el = document.createElement('style');
      el.id = STYLE_ID;
      el.setAttribute('data-kun', 'brand-story-vignette-breathe');
      el.textContent = css;
      (document.head || document.documentElement).appendChild(el);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inject);
    } else {
      inject();
    }
  })();



  // KUN_BRAND_STORY_LOGO_BLACK v1 — true black ground + logo-as-heading polish
  // Scoped to homepage brand story only. Rollback: delete this IIFE (or remove style#kun-brand-story-logo-black).
  // Palette stays palette--dark bg--invert for white type; ground forced to #000 so vignette breathe sits on pure black.
  (function kunBrandStoryLogoBlack() {
    var STYLE_ID = 'kun-brand-story-logo-black';
    function inject() {
      if (document.getElementById(STYLE_ID)) return;
      var css = ""
        + '[id*="section_richtext_kun_story"] > section[data-section-type="rich-text"],'
        + '[id*="section_richtext_kun_story"] > section.palette--dark {'
        + '  background-color: #000 !important;'
        + '  background-image: none;'
        + '}'
        /* Logo image stands in for size-11 KŪN heading — left align, ~58px tall feel, modest gap to etymology */
        + '[id*="section_richtext_kun_story"] .standard__image {'
        + '  margin-left: 0;'
        + '  margin-right: auto;'
        + '  margin-bottom: 0.35em;'
        + '  line-height: 0;'
        + '}'
        + '[id*="section_richtext_kun_story"] .standard__image img,'
        + '[id*="section_richtext_kun_story"] .standard__image .image__img {'
        + '  width: 100%;'
        + '  height: auto;'
        + '  display: block;'
        + '}';
      var el = document.createElement('style');
      el.id = STYLE_ID;
      el.setAttribute('data-kun', 'brand-story-logo-black');
      el.textContent = css;
      (document.head || document.documentElement).appendChild(el);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inject);
    } else {
      inject();
    }
  })();


})();
